import { Component } from '@angular/core';

@Component({
    selector: 'app-menu-preview',
    templateUrl: './menu-preview.component.html',
    styleUrls: ['./menu-preview.component.scss'],
    standalone: false
})
export class MenuPreviewComponent {

}
